import { VariableType } from 'json-to-graphql-query';

import { ListResponse } from '@/interfaces/list';
import { Setting } from '@/interfaces/setting';
import { EntityResource } from './entity.resource';

/**
 * Resource ustawień
 *
 * @export
 * @class SettingResource
 * @extends {EntityResource<Setting>}
 */
export class SettingResource extends EntityResource<Setting> {
  public getFields = {
    id: true,
    code: true,
    value: true,
    description: true,
    valueType: true,
    entityType: true,
    entityId: true
  };

  public listFields = {
    id: true,
    code: true,
    value: true,
    description: true,
    valueType: true,
    entityType: true,
    entityId: true
  };

  public listVariables = { filters: 'SettingFilters' };

  constructor() {
    super({
      entityName: 'setting'
    });
  }

  /**
   * Wyszukiwanie ustawień po kodzie
   *
   * @param {string} code
   * @param {string} entityType
   * @param {string} entityId
   * @returns {Promise<Setting>}
   * @memberof SettingResource
   */
  public findPublic(code: string, entityType?: string, entityId?: string): Promise<Setting> {
    const query = this.prepareOptions({
      query: {
        __variables: { code: 'String!', entityType: 'String', entityId: 'String' },
        settingFindPublic: {
          __args: {
            code: new VariableType('code'),
            entityType: new VariableType('entityType'),
            entityId: new VariableType('entityId')
          },
          ...this.getFields
        }
      }
    });
    return this.query(
      {
        query,
        variables: { code, entityType, entityId }
      },
      'settingFindPublic'
    );
  }

  /**
   * Publiczna lista ustawień
   *
   * @param {*} filters
   * @returns {Promise<ListResponse<Setting>>}
   * @memberof SettingResource
   */
  public publicList(filters: any): Promise<ListResponse<Setting>> {
    const query = this.prepareOptions({
      query: {
        __variables: this.listVariables,
        settingListPublic: {
          __args: this.listArgs,
          list: this.listFields,
          count: true
        }
      }
    });
    return this.query({ query, variables: { filters } }, 'settingListPublic');
  }
}

export const settingResource = new SettingResource();
